var map = {
	"./aletha/receipts-logo.png": [
		743,
		14
	],
	"./ibank/receipts-logo.png": [
		744,
		20
	],
	"./punto/receipts-logo.png": [
		745,
		26
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 485;
module.exports = webpackAsyncContext;